import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { WA_MESSAGES, waLink } from "./data";
import { ArrowCta, Eyebrow, MaskLines, Reveal } from "./ui-bits";

const OffMarket = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section
      ref={ref}
      className="relative flex min-h-[85vh] items-center overflow-hidden"
      data-cursor="view"
      data-testid="offmarket-section"
    >
      <motion.img
        src="/assets/img/dark-arch2.jpg"
        alt="Architecture at dusk"
        style={{ y }}
        className="absolute -top-[15%] left-0 h-[130%] w-full object-cover"
      />
      <div className="absolute inset-0 bg-obsidian/65" />

      <div className="relative z-10 mx-auto w-full max-w-[1440px] px-5 py-28 md:px-10">
        <Eyebrow tone="champagne">Off-Market</Eyebrow>
        <h2 className="mt-6 font-serif text-4xl leading-[1.02] text-ivory sm:text-5xl lg:text-6xl">
          <MaskLines lines={["NOT EVERYTHING", "IS ON THE MARKET."]} />
        </h2>
        <Reveal delay={0.25}>
          <p className="mt-8 max-w-md text-sm leading-relaxed text-ivory/70 md:text-base">
            Some of the most compelling commercial opportunities never reach a
            public listing. Through our landlord and occupier network, Elevate
            provides access to opportunities beyond conventional listings.
          </p>
          <div className="mt-10">
            <ArrowCta href={waLink(WA_MESSAGES.offmarket)} testId="offmarket-cta">
              Request Off-Market Opportunities
            </ArrowCta>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default OffMarket;
